import { render, staticRenderFns } from "./FlagIcons.vue?vue&type=template&id=734f7d3e&scoped=true"
import script from "./FlagIcons.vue?vue&type=script&lang=js"
export * from "./FlagIcons.vue?vue&type=script&lang=js"
import style0 from "./FlagIcons.vue?vue&type=style&index=0&id=734f7d3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734f7d3e",
  null
  
)

export default component.exports